module.exports = __webpack_public_path__ + "img/hmg.2e976b7a.jpg";